import axios from "../axios-auth";

export const supplierProductService = {
    getAllProductBySupplier
};


function getAllProductBySupplier(searchParams, page, size) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size
    };

    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }

    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }

    if (searchParams.productGroupName) {
        params["productGroupName"] = searchParams.productGroupName;
    }

    if (searchParams.supplierId) {
        params["supplierId"] = searchParams.supplierId;
    }

    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/all-products-by-supplier", { params });
}
